export enum DataHook {
  MenuLayoutPanelOptionsThumbnails = 'menu-layout-panel-options-thumbnails',

  PanelsManageAndNavigateSortByDragList = 'manage-and-navigate-panel-sort-by-drag-list',
  PanelsManageAndNavigateSortByDragListFollowers = 'manage-and-navigate-panel-sort-by-drag-list-followers',
}
